import script from "./pagination-bar.vue?vue&type=script&lang=tsx"
export * from "./pagination-bar.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__